import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import NotificationSystem from '@/components/NotificationSystem.vue'
import router from './router'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'bootstrap-icons/font/bootstrap-icons.css'
import '@/assets/css/global.css'

// Inicializar tema al cargar la aplicación
import themeManager from '@/store/theme'
themeManager.init()

import { leerTokensDeUrl, limpiarHashUrl } from '@/utils/subdominio'
import api from '@/services/api'

// Función principal: espera a tener datos de usuario antes de montar la app
;(async function iniciarApp () {
  // ── Cierre de sesión cross-subdomain ───────────────────────────────────────
  // Cuando el usuario cierra sesión desde {empresa}.sicecom.com, se redirige a
  // app.sicecom.com/iniciar-sesion?accion=cerrar-sesion para que se limpien
  // los tokens del localStorage de app.sicecom.com ANTES de hidratar el store.
  const searchParams = new URLSearchParams(window.location.search)
  if (searchParams.get('accion') === 'cerrar-sesion') {
    const clavesLimpiar = [
      'token_acceso_cliente', 'token_refresco_cliente',
      'usuario_cliente', 'modulos_cliente', 'suscripcion_cliente',
      'client_access_token', 'client_refresh_token',
      'client_user', 'client_modules', 'client_subscription'
    ]
    clavesLimpiar.forEach(c => localStorage.removeItem(c))
    // Eliminar el parámetro de la URL sin recargar
    history.replaceState(null, '', window.location.pathname)
  }
  // ──────────────────────────────────────────────────────────────────────────

  // ── Handoff de tokens cross-subdomain ──────────────────────────────────────
  // Cuando el usuario hace login en app.sicecom.com, el frontend redirige a
  // {empresa}.sicecom.com/#t=TOKEN&r=REFRESH. Este bloque los captura y además
  // obtiene perfil/módulos del backend porque el localStorage del subdominio
  // de empresa no tiene acceso al localStorage de app.sicecom.com.
  const tokensHandoff = leerTokensDeUrl()
  if (tokensHandoff) {
    localStorage.setItem('token_acceso_cliente', tokensHandoff.tokenAcceso)
    if (tokensHandoff.tokenRefresco) {
      localStorage.setItem('token_refresco_cliente', tokensHandoff.tokenRefresco)
    }
    limpiarHashUrl()

    // Obtener datos de usuario/módulos/suscripción desde el backend
    // (no están en el localStorage de este subdominio)
    try {
      const { data } = await api.get('/autenticacion/cliente/perfil')
      if (data?.user) {
        localStorage.setItem('usuario_cliente', JSON.stringify(data.user))
        store.commit('setUser', data.user)
      }
      if (data?.modules) {
        localStorage.setItem('modulos_cliente', JSON.stringify(data.modules))
        store.commit('setModules', data.modules)
      }
      if (data?.subscription) {
        localStorage.setItem('suscripcion_cliente', JSON.stringify(data.subscription))
        store.commit('setSubscription', data.subscription)
      }
    } catch (e) {
      console.error('[Startup] No se pudo obtener perfil tras handoff:', e?.message || e)
    }
  } else {
    // Flujo normal: hidratar desde localStorage (recarga de página, etc.)
    store.dispatch('hydrateFromStorage')
  }
  // ──────────────────────────────────────────────────────────────────────────

  // Chequeo no bloqueante de salud del backend para depurar CORS/red
  api.get('/salud')
    .then(() => api.get('/salud').catch(() => {}))
    .catch(e => {
      console.error('[Startup] No se pudo conectar al backend en', api.defaults.baseURL, e?.message || e)
      console.warn('Verifica que Apache/XAMPP esté corriendo y que la ruta', api.defaults.baseURL, 'sea accesible desde el navegador.')
    })

  const app = createApp(App)
  app.use(store)
  app.use(router)
  app.component('NotificationSystem', NotificationSystem)
  app.mount('#app')
})()

